import ReviewCard from "components/common/Card/ReviewCard";
import Carousel from "components/common/Carousel";
import { lifeChoiseDetailsDesktop } from "constantVariables";
import useMediaQuery from "hooks/useMediaQuery";
import React, { useMemo } from "react";

const Comments = ({ items, title, slidesPerView }) => {
  const isDesktop = useMediaQuery(lifeChoiseDetailsDesktop);
  const carouselOptions = useMemo(
    () =>
      isDesktop
        ? {
            slidesPerView: slidesPerView
              ? slidesPerView
              : items.length >= 4
              ? 4
              : items.length,
            pagination: { clickable: true },
          }
        : { pagination: { clickable: true } },
    [isDesktop]
  );

  const renderItem = (item) => (
    <ReviewCard
      className="career-review-card"
      cardType="careerCard"
      title={title}
      item={item}
      itemType={!isDesktop ? "secondry" : "primary"}
    />
  );

  return (
    <div className={`comments  ${!isDesktop && "container-right-aligned"}`}>
      <Carousel
        items={items}
        renderItem={renderItem}
        options={carouselOptions}
        className={"pb-0"}
      />
    </div>
  );
};

export default Comments;
